export default {
  OUTBOUND: 'OUTBOUND',
  INBOUND: 'INBOUND',
};
